export default "__VITE_ASSET__CcWMRDYF__"